import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

import Navigator from '../../Navigator';
import client from '../../../api/graphql/graphqlAPI';

const GET_PAGE_LAYOUT_LIST = gql`
  query getPageLayoutList {
    getPageLayoutList {
      layout
      description
      image
    }
  }
`;

const LayOutList = (props) => {
  const { location: { pathname } } = props;
  const { loading, error, data } = useQuery(GET_PAGE_LAYOUT_LIST, {
    client,
  });

  if (error) return <p>{error}</p>;
  if (loading) return <p>Loading Layout...</p>;
  if (!data?.getPageLayoutList) return null;

  return (
    <>
      <Navigator />
      <div className="choose-layout">
        <h2 className="mt-4 mb-6 text-26 font-americaBlack sm:text-20 md:text-18 capitalize">Choose master layout</h2>
        {data.getPageLayoutList.map(listItem => (
          <Link to={`${pathname}/${listItem.layout}`} key={listItem.layout}>
            <div className="p-4 flex cursor-pointer items-center bg-white mb-4 rounded h-100px">
              <div className="img bg-grey w-123px justify-center self-stretch items-center flex" />
              <div className="title pl-8 self-center font-semibold text-black">{listItem.description}</div>
            </div>
          </Link>
        ))}
      </div>
    </>
  );
};

LayOutList.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(LayOutList);
